/**
 * Karbon360° v2 — reporting-period selection.
 *
 * Holds the workspace-wide reporting period shown in the topbar switcher and
 * persists it across reloads. Real, persisted state — but note that NO screen
 * consumes it yet: the existing pages each own their own month/year pickers.
 * Phase 2 onward reads this via useReportingPeriod() as screens are rebuilt.
 */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { PERIOD_OPTIONS } from './nav-model';

const KEY = 'k360-reporting-period';
const Ctx = createContext(null);

export function ReportingPeriodProvider({ children }) {
  const [period, setPeriodState] = useState(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (saved && PERIOD_OPTIONS.includes(saved)) return saved;
    } catch { /* ignore */ }
    return PERIOD_OPTIONS[0];
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, period); } catch { /* ignore */ }
  }, [period]);

  const value = useMemo(
    () => ({ period, setPeriod: setPeriodState, options: PERIOD_OPTIONS }),
    [period]
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useReportingPeriod() {
  const ctx = useContext(Ctx);
  if (!ctx) {
    // Rendered outside the shell (e.g. login) — degrade rather than throw.
    return { period: PERIOD_OPTIONS[0], setPeriod: () => {}, options: PERIOD_OPTIONS };
  }
  return ctx;
}
